import React from 'react';
import styled from 'styled-components';
import { useField } from 'react-final-form';

const Text = ({
  placeholder, name, label, textarea, className, ...rest
}) => {
  const { input, meta } = useField(name, rest);

  const error = meta.touched && (meta.error || meta.submitError);

  const InputComponent = textarea ? TextArea : Input;

  const onChange = ({ target }) => (rest.type === 'number'
    ? input.onChange(parseInt(target.value, 10))
    : input.onChange(target.value));

  return (
    <Container className={className}>
      {label && <label className="label">{label}</label>}
      <InputContainer>
        <InputComponent
          placeholder={placeholder}
          {...input}
          disabled={rest.disabled}
          onChange={onChange}
          error={!!error}
        />
        {rest.children}
      </InputContainer>
      {error && <p className="help is-danger">{error}</p>}
    </Container>
  );
};

export default Text;

const Container = styled.div`
  min-width: 100px;
`;

const InputContainer = styled.div`
  display: flex;
  min-width: 50px;
`;

const Input = styled.input`
  background-color: ${({ disabled }) => (disabled ? '#f2f2f2' : '#ffffff')};
  border: 1px solid ${({ error }) => (error ? '#ff3860' : '#dbdbdb')};
  color: ${({ disabled }) => (disabled ? 'grey' : '#363636')};
  border-radius: 4px;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  padding: 9px 8px;
  width: 100%;
  box-sizing: border-box;
`;

const TextArea = styled.textarea`
  background-color: ${({ disabled }) => (disabled ? 'f2f2f2' : '#ffffff')};
  border: 1px solid ${({ error }) => (error ? '#ff3860' : '#dbdbdb')};
  color: ${({ disabled }) => (disabled ? 'grey' : '#363636')};
  border-radius: 4px;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  padding: 8px 9px;
  width: 100%;
  box-sizing: border-box;
  min-height: 100px;
`;
